define(
({
  "alert": "Waarschuwing",
  "okay": "Oké"
})
);
